import { get } from 'lodash'
import { getGender } from 'lib/birthNumber'
import { uppercaseFirst } from 'lib/utils'

/*
  string: Default text. Use %s to replace word with: du/hun/han
  values: The form data where we figure out what sex it is
  alternativeString: An alternative string to use if the form is filled out on behalf of someone (optional)
*/

export default function getGenderText(string, values, alternativeString) {
  const knownGender = !!get(values, 'details.on_behalf_of.national_id')
  const onBehalfOfGender = getGender(get(values, 'details.on_behalf_of.national_id'))
  const gender = onBehalfOfGender === 'MALE' ? 'han' : 'hun'
  const str = knownGender && alternativeString ? alternativeString : string

  const resultString = str
    .replace(/%S/g, uppercaseFirst(String(knownGender ? gender : 'du')))
    .replace(/%s/g, knownGender ? gender : 'du')

  return resultString
}
